import axios from "axios";
import { createContext, useContext, useEffect, useState, useCallback } from "react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

const AuthCtx = createContext({ user: null, affiliate: null, loading: true });

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [affiliate, setAffiliate] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // AuthCallback will exchange the session_id and establish the session first.
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    try {
      const res = await axios.get(`${API}/auth/me`, { withCredentials: true });
      setUser(res.data?.user || null);
      setAffiliate(res.data?.affiliate || null);
    } catch (e) {
      setUser(null);
      setAffiliate(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const logout = async () => {
    try {
      await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
    } catch (_) {}
    setUser(null);
    setAffiliate(null);
  };

  return (
    <AuthCtx.Provider value={{ user, affiliate, loading, refresh, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  return useContext(AuthCtx);
}

/**
 * Fire the Emergent Auth flow — Google popup → `?session_id=...` fragment.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export function signInWithGoogle(nextPath = "/affiliate/dashboard") {
  const redirect = window.location.origin + nextPath;
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`;
}
